import template from './diversificationOpportunity.template.html';
import templateTicketRefer from '../ticket/ticketRefer.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    diversificationOpportunities: '<',
    opportunityContextualType: '<',
    contacts: '<',
    addresses: '<',
    documents: '<',
    outboundReferrers: '<',
    loan: '<',
    ticketOwner: '<',
    ticket: '<',
    idWorkflow: '<',
    idContact: '<',
    idAli: '<',
    hasMargin: '<',
    onIntegrationFinished: '&',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $mdMedia,
      $mdMenu,
      $mdDialog,
      helperService,
      OpportunityType,
      OpportunityContextualType,
      OpportunitySelectionType,
      OpportunityContextual,
      diversificationOpportunityService,
      accessService
    ) {
      'ngInject';

      /*
       * Controller model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.organizationCountry = '';
      ctrl.opportunitySelectionTypes = [];
      ctrl.availableDiversificationOpportunities = [];
      ctrl.availableReferrals = [];
      ctrl.isReady = false;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.opportunitySelectionTypes = OpportunitySelectionType.available();
        ctrl.diversificationOpportunities = ctrl.diversificationOpportunities || [];
        ctrl.opportunityContextualType = ctrl.opportunityContextualType || {};
        ctrl.contacts = ctrl.contacts || [];
        ctrl.addresses = ctrl.addresses || [];
        ctrl.documents = ctrl.documents || [];
        ctrl.outboundReferrers = ctrl.outboundReferrers || [];
        ctrl.loan = ctrl.loan || {};
        ctrl.ticketOwner = ctrl.ticketOwner || {};
        ctrl.ticket = ctrl.ticket || {};
        ctrl.ticketValue = ctrl.ticket?.values?.onceOff || 0;
        ctrl.ticketClientTypes = ctrl.ticket?.ticketClientTypes || [];
        ctrl.idTicket = ctrl.ticket?.id || '';
        ctrl.idOwner = ctrl.idOwner || ctrl.ticketOwner?.id || '';
        ctrl.idWorkflow = ctrl.ticket?.idWorkflow || '';
        ctrl.idContact = ctrl.idContact || '';
        ctrl.idAli = ctrl.idAli || '';
        ctrl.opportunity = {};
        ctrl.hasMargin = ctrl.hasMargin || false;
        ctrl.isShowing =
          diversificationOpportunityService.showDiversificationOpportunity({
            opportunity: OpportunityContextualType.of(ctrl.opportunityContextualType.name),
            owner: ctrl.ticketOwner,
            isTicket: true
          }) || false;
        ctrl.setContextualOpportunity();
        ctrl.isReady = true;
      };

      ctrl.setContextualOpportunity = () => {
        const referrals = _.filter(
          _.find(
            ctrl.currentOrganization?.features?.configDiversification,
            (d) => d?.type?.name === ctrl.opportunityContextualType?.type
          )?.configuration,
          (c) => c?.name && c?.referral && c?.template
        );
        const accessReferrals = _.filter(
          ctrl.outboundReferrers,
          (o) => o?.diversification?.type === ctrl.opportunityContextualType?.type
        );
        ctrl.availableReferrals = referrals.concat(accessReferrals);

        const opportunity = _.find(
          ctrl.diversificationOpportunities,
          (o) => o?.typeContextual?.name === ctrl.opportunityContextualType?.name
        );
        if (opportunity) {
          ctrl.opportunity = OpportunityContextual.build(opportunity);
        } else {
          const contextualType = OpportunityContextualType.of(
            ctrl.opportunityContextualType.name
          );
          const type = OpportunityType.of(ctrl.opportunityContextualType.type);
          ctrl.opportunity = OpportunityContextual.blank(type, contextualType);
          ctrl.diversificationOpportunities.push(ctrl.opportunity);
        }
      };

      ctrl.changeOpportunitySelection = () => {
        const idx = _.findIndex(
          ctrl.diversificationOpportunities,
          (o) => o?.typeContextual?.name === ctrl.opportunity.typeContextual?.name
        );
        if (idx > -1) {
          ctrl.diversificationOpportunities[idx] = ctrl.opportunity;
        }
        ctrl.onFinished({ diversificationOpportunities: ctrl.diversificationOpportunities });
      };

      ctrl.isReferralSetOnOpportunityGroup = () =>
        diversificationOpportunityService.isReferralSetOnOpportunityGroup({
          typeName: ctrl.opportunity?.typeContextual?.type
        });

      ctrl.isAccepted = () =>
        ctrl.opportunity?.selection?.name === OpportunitySelectionType.accepted.name;

      ctrl.isDeclined = () =>
        ctrl.opportunity?.selection?.name === OpportunitySelectionType.declined.name;

      ctrl.isNotDiscussed = () =>
        ctrl.opportunity?.selection?.name === OpportunitySelectionType.not_discussed.name;

      ctrl.hasSelectionMade = () =>
        ctrl.opportunity?.selection?.name !== OpportunitySelectionType?.none?.name;

      ctrl.referTicket = (a) => {
        function ticketReferController(access, ticket) {
          this.access = access;
          this.ticket = ticket;
          this.confirm = () => {
            $mdDialog.hide(true);
          };
          this.cancel = () => {
            $mdDialog.cancel(false);
          };
        }

        $mdDialog
          .show({
            locals: {
              access: a,
              ticket: ctrl.ticket
            },
            template: templateTicketRefer,
            controllerAs: '$ctrl',
            controller: ticketReferController
          })
          .then((result) => {
            if (result === true) {
              accessService.refer({
                idAccess: a.id,
                idTicket: ctrl.ticket.id
              });
            }
          });
      };

      ctrl.openReferral = ({ configuration }) => {
        if (configuration?.idWorkflow) {
          ctrl.referTicket(configuration);
        } else {
          diversificationOpportunityService.sendReferralEmail({
            configuration,
            documents: ctrl.documents,
            idTicket: ctrl.idTicket,
            idOwner: ctrl.idOwner,
            idWorkflow: ctrl.idWorkflow,
            idContact: ctrl.idContact,
            isTicket: true
          });
        }
      };

      ctrl.integrationFinished = (integration, result) => {
        ctrl.onIntegrationFinished({ integration, result });
      };

      ctrl.showReferralButton = () =>
        diversificationOpportunityService.showReferralButton({
          opportunity: ctrl.opportunity?.typeContextual?.type,
          owner: ctrl.ticketOwner,
          isTicket: true
        });

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
